enum ROLES {
    'USER' = 'USER',
    'CREATOR' = 'CREATOR',
    'ADMIN' = 'ADMIN'
}

export default ROLES